<template>
  <v-app>
    <Drawer />
    <Views />
  </v-app>
</template>

<script>
import * as Sentry from '@sentry/vue'
import Drawer from '../components/Drawer'
import Views from '../components/Views'

export default {
  components: {
    Drawer,
    Views,
  },
  created() {
    const { id, username, email } = this.$store.state.user.user
    Sentry.setUser({
      id,
      username,
      email
    })
  }
};
</script>
<style>
  th>span {
    white-space: nowrap;
  }
</style>
